import { useState, useEffect } from 'react'
import dayjs, { Dayjs } from 'dayjs'

export const useCurrentTime = (timezone: string) => {
  const [time, setTime] = useState<Dayjs>(dayjs())
  const [interval, setTimeInterval] = useState<any>()

  useEffect(() => {
    if (interval) clearInterval(interval)

    setTimeInterval(
      setInterval(() => {
        setTime(dayjs())
      }, 30000),
    )
    return () => {
      if (interval) clearInterval(interval)
    }
  }, [timezone]) // eslint-disable-line react-hooks/exhaustive-deps

  return time
}
